import { FormControl, Input, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import API from "../API";
import dayjs from "dayjs";

export function ReschedulerForm({ _id, hubspotId, name, setLoading, setSubmitDisabled, row, sendRescheduleEmail }) {
    const [email, setEmail] = useState(row?.rescheduler?.email ?? '');
    const [plan, setPlan] = useState(row?.rescheduler?.plan?.toLowerCase() ?? '');
    const [planStartDate, setPlanStartDate] = useState(row?.rescheduler?.planStartDate ? dayjs(row?.rescheduler?.planStartDate) : null);
    const [originalDate, setOriginalDate] = useState(row?.rescheduler?.originalDate ? dayjs(row?.rescheduler?.originalDate) : null);
    const [currentDate, setCurrentDate] = useState(row?.rescheduler?.currentDate ? dayjs(row?.rescheduler?.currentDate) : null);
    const [incomplete, setIncomplete] = useState(false);

    async function submitReschedulerForm(event) {
        event.preventDefault();

        try {
            setLoading(true);

            await API.post("/ivisa/rescheduler", {
                _id,
                hubspotId,
                email,
                name,
                plan,
                planStartDate,
                originalDate,
                currentDate,
                sendRescheduleEmail,
            });

            window.location.reload();
        }
        catch (error) {
            toast.error('Failed to submit rescheduler form', { duration: 3000 });
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const fields = [email, plan, planStartDate, originalDate];
        const isMissing = fields.some((field) => !field);

        if (isMissing || incomplete) {
            setSubmitDisabled(true);
        }
        else {
            setSubmitDisabled(false);
        }
    }, [email, plan, planStartDate, originalDate, incomplete]);

    return (
        <form id="rescheduler-form" name="rescheduler-form" onSubmit={submitReschedulerForm}
            style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '1rem' }}>
            <InputLabel focused>Client</InputLabel>
            <FormControl fullWidth>
                <InputLabel>Email</InputLabel>
                <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
            </FormControl>
            <InputLabel focused>Plan</InputLabel>
            <FormControl fullWidth>
                <InputLabel id="category-select-label">Category</InputLabel>
                <Select
                    labelId="category-select-label"
                    id="category-select"
                    value={plan}
                    label="Category"
                    onChange={(event) => setPlan(event.target.value)}
                    required
                >
                    <MenuItem value={"cat-a"}>CAT-A</MenuItem>
                    <MenuItem value={"cat-b"}>CAT-B</MenuItem>
                    <MenuItem value={"cat-c"}>CAT-C</MenuItem>
                    <MenuItem value={"cat-d"}>CAT-D</MenuItem>
                </Select>
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Plan Start Date"
                    value={planStartDate}
                    onChange={(newValue) => {
                        setPlanStartDate(newValue ? dayjs(newValue).toDate() : null);
                    }}
                    renderInput={(params) => <TextField {...params} required />}
                    onError={() => setIncomplete(true)}
                    onAccept={() => setIncomplete(false)}
                />
                <InputLabel focused>Appointment</InputLabel>
                <DatePicker
                    label="Original Date"
                    value={originalDate}
                    onChange={(newValue) => {
                        setOriginalDate(newValue ? dayjs(newValue).toDate() : null);
                    }}
                    renderInput={(params) => <TextField {...params} required />}
                    onError={() => setIncomplete(true)}
                    onAccept={() => setIncomplete(false)}
                />
                <DatePicker
                    label="Current Date"
                    value={currentDate}
                    onChange={(newValue) => {
                        setCurrentDate(newValue ? dayjs(newValue).toDate() : null);
                    }}
                    renderInput={(params) => <TextField {...params} required />}
                    onError={() => setIncomplete(true)}
                    onAccept={() => setIncomplete(false)}
                />
            </LocalizationProvider>
        </form>
    );
}